// extracted by mini-css-extract-plugin
export var attachButton = "_cf-8";
export var sendButton = "_cf-2";
export var sendDisabled = "_cf-4";
export var sendEnabled = "_cf-3";
export var sendIcon = "_cf-6";
export var sendIconDisabled = "_cf-7";
export var sendStreaming = "_cf-5";
export var textarea = "_cf-1";
export var wrapper = "_cf-0";